import { env } from "process";

export var global = {    
//   url: 'http://localhost:9000/api/', 
//    url: 'https://apialpha.nectum-investment.com/api/',
    url: 'https://apialpha.nectum-investment.com/api/',
    wsUrl: 'wss://apialpha.nectum-investment.com/',
    ApiibrkUlr: 'http://localhost/',
    currentVersion: 'V.04112026.5',
    mesesLimite: 6, // Número de meses para el límite de datos históricos
    timezone: {
        default: 'SPAIN',  // Default timezone for trading
        format: 'UTC',               // Time format to use
        offsetHours: 2,            // EDT offset from UTC
        useLocalTime: false,        // Whether to use browser's local time
        tradingHours: {
            start: '09:30',         // Market open time (ET)
            end: '16:00'            // Market close time (ET)
        }
    },
    session: {
        isDev: false,
        useGw: false,
        baseUrlReal: 'https://app.nectum-investment.com/api/v1/api',
        baseUrl: 'https://api.ibkr.com/v1/api',
        gwBaseUrl: 'https://localhost:8443/v1/api',
        gwBaseUrlLogin: 'https://localhost:8443/',
        // Nectum MT5 Gateway local: misma REST que MetaApi sobre el terminal MetaTrader 5 del usuario
        mt5GwBaseUrl: 'https://localhost:8444',
        mt5GwWsUrl: 'wss://localhost:8444/gateway/ws/prices',
        mt5GwInstaller: '/agente/MT5GatewayInstaller.exe',
    },
    credentials: {
        consKey: 'NECTINVST',//NECTINVST.NCTMINVST
        realm: 'limited_poa',//limited_poa.. test_realm 
        accessToken: '',
        liveSessionToken: '',
        url: '',
        urlReal: '',
        endPoint: '',
        useGw: false,
        requestToken: '',
        verifier: '', diffieHellmanChallenge: '', prepend: '', lstBigInt: null
    },
    oauth: {
        requestToken: '',
        verifier: '',
        tokenSecret: '',
        oauthTipo: 1 /**   1 first, 3 thirth party  */
    },
    // Las claves privadas del consumer de IBKR ya NO viven aqui: el bundle es publico.
    // La firma OAuth (request_token, access_token y live_session_token) la hace el backend
    // en /api/ibkr/oauth/**, que lee los PEM de fuera del repo (IbkrOAuthService).
    output: {
        value: ''
    }
}